import screenfull from 'screenfull'

export default {
  namespaced: true,
  state: {
    active: false //是否开启网页全屏
  },
  mutations: {
    /**
     * 设置全屏状态
     */
    set(state, active) {
      state.active = active
    }
  },
  actions: {
    /**
     * 监听全屏状态
     */
    observe({ commit }) {
      if (screenfull.isEnabled) {
        screenfull.on('change', () => {
          if (!screenfull.isFullscreen) {
            commit('set', false)
          }
        })
      }
    },

    /**
     * 切换全屏
     */
    toggle({ commit }) {
      if (screenfull.isFullscreen) {
        screenfull.exit()
        commit('set', false)
      } else {
        screenfull.request()
        commit('set', true)
      }
    }
  }
}
